<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Waitlisted Students</h3>
                <student-table
                    :items="students"
                    :attendable="event"
                    :sort-by="sort_by"
                    :columns="['first_name','last_name','email']"
                    attendable-type="event"
                    @sort-change="sortChange">
                    <template slot="actions">
                        <el-table-column label="Actions" width="150px" align="right">
                            <template slot-scope="scope">
                                <app-button
                                    size="mini"
                                    @click.stop="handlePromote(scope.$index, scope.row)">Upgrade</app-button>
                            </template>
                        </el-table-column>
                    </template>
                </student-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import table from '@/mixins/table'

import StudentTable from '../Student/StudentTable'

import Event from '@/store/models/Event'
import Student from '@/store/models/Student'

export default {
    name: 'page-event-detail-students',
    components: {
        StudentTable
    },
    mixins: [table],
    props: ['event'],
    data() {
        return {
            showAddStudent: false,
            relation: 'waitlist',
            tableParamKeys: ['relation_uuid', 'relation'],
            students: [],
            total: 0
        }
    },
    computed: {
        relation_uuid() {
            return this.event.uuid
        }
    },
    mounted() {
        this.getStudents(this.getParameters())
    },
    methods: {
        getStudents(params) {
            Student.$fetch({
                graphql: 'relation',
                variables: params
            }).then(({ data, raw }) => {
                this.students = data
                this.total = raw.total
            })
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        paramsChanged(params) {
            this.getStudents(params)
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        },
        handlePromote(index, row) {
            Event.$mutate({
                graphql: 'upgradeStudent',
                variables: {
                    event_id: this.event.id,
                    student_id: row.id
                }
            })
                .then(() => {
                    this.getStudents(this.getParameters())
                })
        }
    }
}
</script>

<style lang="stylus"></style>
